<template>
  <div>
    <form
      v-if="status === 'success'"
      class="kt-form"
      @submit.prevent="update"
      id="profile_form"
    >
      <div>
        <div class="h5 mb-4">
          <i class="text-success far fa-building"></i>
          <span class="px-4">{{ $t("legal_user.label.company_info") }}</span>
        </div>
        <div>
          <div class="row">
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="username">
                  {{ $t("label.username_with_hint") }}
                </label>
                <input type="text" class="form-control"
                  dir="ltr"
                  name="username"
                  id="username"
                  v-model="user.username"
                >
                <div
                  :class="['text-danger', (!is_username_valid() && has_submit_attempt) ? '' : 'd-none']"
                >
                  <small v-text="error_msg.username"></small>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="email">
                  {{ $t("label.email") }}
                </label>
                <input type="text" class="form-control"
                  dir="ltr"
                  name="email"
                  id="email"
                  v-model="user.email"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="com_name_fa">
                  {{ $t("label.com_name_fa") }}
                </label>
                <input type="text" class="form-control"
                  id="com_name_fa"
                  name="com_name_fa"
                  v-model="user.com_name_fa"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="com_name_en">
                  {{ $t("label.com_name_en") }}
                </label>
                <input type="text" class="form-control"
                  id="com_name_en"
                  name="com_name_en"
                  dir="ltr"
                  v-model="user.com_name_en"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="national_legal_code">
                  {{ $t("label.national_legal_code") }}
                </label>
                <input type="text" class="form-control"
                  id="national_legal_code"
                  name="national_legal_code"
                  v-model="user.national_legal_code"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="register_number">
                  {{ $t("label.register_number") }}
                </label>
                <input type="text" class="form-control"
                  id="register_number"
                  name="register_number"
                  v-model="user.register_number"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="register_date">
                  {{ $t("label.com_register_date") }}
                </label>
                <datePicker
                  color="#00c1a4"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="jDD jMMMM jYYYY"
                  input-class="form-control"
                  id="register_date"
                  name="register_date"
                  v-model="user.register_date"
                  type="date"
                />
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="telephone">
                  {{ $t("label.telephone") }}
                </label>
                <input type="text" class="form-control"
                  ref="telephone"
                  dir="ltr"
                  name="telephone"
                  id="telephone"
                  v-model="user.telephone"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="phone">
                  {{ $t("label.phone") }}
                </label>
                <input type="text" class="form-control"
                  dir="ltr"
                  disabled
                  name="phone"
                  id="phone"
                  :value="user.phone"
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr style="border-top: 1px solid #dedede;" class="my-4">

      <div>
        <div class="h5 mb-4">
          <i class="text-success fas fa-file-signature"></i>
          <span class="px-4">{{
            $t("legal_user.label.signature_holder_info")
          }}</span>
        </div>
        <div>
          <div class="row">
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="signature_holder_first_name_fa">
                  {{ $t("label.first_name") }}
                </label>
                <input type="text" class="form-control"
                  name="signature_holder_first_name_fa"
                  id="signature_holder_first_name_fa"
                  v-model="user.signature_holder.first_name_fa"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="signature_holder_first_name_en">
                  {{ $t("label.first_name_en") }}
                </label>
                <input type="text" class="form-control"
                  dir="ltr"
                  name="signature_holder_first_name_en"
                  id="signature_holder_first_name_en"
                  v-model="user.signature_holder.first_name_en"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="signature_holder_last_name_fa">
                  {{ $t("label.last_name") }}
                </label>
                <input type="text" class="form-control"
                  name="signature_holder_last_name_fa"
                  id="signature_holder_last_name_fa"
                  v-model="user.signature_holder.last_name_fa"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="signature_holder_last_name_en">
                  {{ $t("label.last_name_en") }}
                </label>
                <input type="text" class="form-control"
                  dir="ltr"
                  name="signature_holder_last_name_en"
                  id="signature_holder_last_name_en"
                  v-model="user.signature_holder.last_name_en"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="signature_holder_father_name_fa">
                  {{ $t("label.father_name") }}
                </label>
                <input type="text" class="form-control"
                  name="signature_holder_father_name_fa"
                  id="signature_holder_father_name_fa"
                  v-model="user.signature_holder.father_name_fa"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="signature_holder_father_name_en">
                  {{ $t("label.father_name_en") }}
                </label>
                <input type="text" class="form-control"
                  dir="ltr"
                  name="signature_holder_father_name_en"
                  id="signature_holder_father_name_en"
                  v-model="user.signature_holder.father_name_en"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="signature_holder_birth_date">
                  {{ $t("label.birth_date") }}
                </label>
                <datePicker
                  color="#00c1a4"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="dddd jDD jMMMM jYYYY"
                  input-class="form-control"
                  id="signature_holder_birth_date"
                  name="signature_holder_birth_date"
                  v-model="user.signature_holder.birth_date"
                  type="date"
                />
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="signature_holder_national_code">
                  {{ $t("label.national_code") }}
                </label>
                <input type="text" class="form-control"
                  dir="ltr"
                  maxlength="10"
                  name="signature_holder_national_code"
                  id="signature_holder_national_code"
                  v-model="user.signature_holder.national_code"
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr style="border-top: 1px solid #dedede;" class="my-4">

      <div>
        <div class="h5 mb-4">
          <i class="text-success fas fa-laptop-code"></i>
          <span class="px-4">{{
            $t("legal_user.label.technical_agent_info")
          }}</span>
        </div>
        <div>
          <div class="row">
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="technical_agent_first_name">
                  {{ $t("label.first_name") }}
                </label>
                <input type="text" class="form-control"
                  name="technical_agent_first_name"
                  id="technical_agent_first_name"
                  v-model="user.technical_agent.first_name"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="technical_agent_last_name">
                  {{ $t("label.last_name") }}
                </label>
                <input type="text" class="form-control"
                  id="technical_agent_last_name"
                  name="technical_agent_last_name"
                  v-model="user.technical_agent.last_name"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="technical_agent_phone_number">
                  {{ $t("label.phone") }}
                </label>
                <input type="text" class="form-control"
                  dir="ltr"
                  id="technical_agent_phone_number"
                  name="technical_agent_phone_number"
                  v-model="user.technical_agent.phone_number"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="technical_agent_telephone_number">
                  {{ $t("label.telephone") }}
                </label>
                <input type="text" class="form-control"
                  dir="ltr"
                  id="technical_agent_telephone_number"
                  name="technical_agent_telephone_number"
                  v-model="user.technical_agent.telephone_number"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="technical_agent_email">
                  {{ $t("label.email") }}
                </label>
                <input type="text" class="form-control"
                  dir="ltr"
                  id="technical_agent_email"
                  name="technical_agent_email"
                  v-model="user.technical_agent.email"
                >
              </div>
            </div>
            <div class="col-12 col-md-6 my-2">
              <div>
                <label for="technical_agent_national_code">
                  {{ $t('label.national_code') }}
                </label>
                <input type="text" class="form-control"
                  dir="ltr"
                  id="technical_agent_national_code"
                  name="technical_agent_national_code"
                  v-model="user.technical_agent.national_code"
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center px-3 mt-4">
        <div class="mr-auto">
            <button
            type="submit"
            class="btn btn-success px-4"
            style="border-radius: 10px"
            id="submit_btn"
            :disabled="form_submit_loading"
            >
            <span v-if="form_submit_loading">
                <span class="pl-2">در حال انجام</span>
                <span
                class="spinner-border spinner-border-sm p-2"
                role="status"
                ></span>
            </span>
            <span v-else>مرحله بعد</span>
            </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import { mapState } from "vuex";
import { userService } from "@/common/api.service";
import Inputmask from "inputmask";
import { i18n } from "@/plugins/i18n";
import { birthCrtfctSeriesLetters } from "@/constants/birthCrtfctSeriesLetter";
import p2f from 'persian-to-pinglish';
import { getFinglish } from '@/constants/names';

export default {
  props: {
    wizard: Object,
    user: Object,
  },
  data() {
    return {
      has_submit_attempt: false,
      error_msg: {
        username: "",
      },
      form_submit_loading: false,
      birthCrtfctSeriesLetters: birthCrtfctSeriesLetters,
      months: [
        {
          title: i18n.t("month.farvardin"),
          value: 1,
        },
        {
          title: i18n.t("month.ordibehesht"),
          value: 2,
        },
        {
          title: i18n.t("month.khordad"),
          value: 3,
        },
        {
          title: i18n.t("month.tir"),
          value: 4,
        },
        {
          title: i18n.t("month.mordad"),
          value: 5,
        },
        {
          title: i18n.t("month.shahrivar"),
          value: 6,
        },
        {
          title: i18n.t("month.mehr"),
          value: 7,
        },
        {
          title: i18n.t("month.aban"),
          value: 8,
        },
        {
          title: i18n.t("month.azar"),
          value: 9,
        },
        {
          title: i18n.t("month.day"),
          value: 10,
        },
        {
          title: i18n.t("month.bahman"),
          value: 11,
        },
        {
          title: i18n.t("month.esfand"),
          value: 12,
        },
      ],
    };
  },
  computed: {
    ...mapState("user", {
      status: (state) => state.status,
    }),
    user_com_name_fa() {
      return this.user.com_name_fa;
    },
    user_signature_holder_first_name_fa() {
      return this.user.signature_holder.first_name_fa;
    },
    user_signature_holder_last_name_fa() {
      return this.user.signature_holder.last_name_fa;
    },
    user_signature_holder_father_name_fa() {
      return this.user.signature_holder.father_name_fa;
    },
  },
  watch: {
    user_com_name_fa() {
      let finglish = getFinglish(this.user.com_name_fa);
      
      if (finglish) {
        this.user.com_name_en = finglish;
      } else {
        this.user.com_name_en = p2f(this.user.com_name_fa);
      }
    },
    user_signature_holder_first_name_fa() {
      let finglish = getFinglish(this.user.signature_holder.first_name_fa);
      
      if (finglish) {
        this.user.signature_holder.first_name_en = finglish;
      } else {
        this.user.signature_holder.first_name_en = p2f(this.user.signature_holder.first_name_fa);
      }
    },
    user_signature_holder_last_name_fa() {
      let finglish = getFinglish(this.user.signature_holder.last_name_fa);
      
      if (finglish) {
        this.user.signature_holder.last_name_en = finglish;
      } else {
        this.user.signature_holder.last_name_en = p2f(this.user.signature_holder.last_name_fa);
      }
    },
    user_signature_holder_father_name_fa() {
      let finglish = getFinglish(this.user.signature_holder.father_name_fa);
      
      if (finglish) {
        this.user.signature_holder.father_name_en = finglish;
      } else {
        this.user.signature_holder.father_name_en = p2f(this.user.signature_holder.father_name_fa);
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.initialSetup();
    });
  },
  methods: {
    is_username_valid() {
      if (this.user.username == null || this.user.username == "") {
        this.error_msg.username = "تکمیل این فیلد اجباری است.";
        return false;
      } 
      
      if (this.user.username.length < 5) {
        this.error_msg.username = "نام کاربری باید بیشتراز پنج کاراکتر باشد.";
        return false;
      }
      
      if(!(this.user.username.match("^[a-zA-Z0-9]{5,15}$"))) {
        this.error_msg.username = "نام کاربری باید شامل حروف انگلیسی و اعداد باشد";
        return false;
      }

      return true;
    },
    checkForDisableForm() {
      if (this.user.is_authenticated) {
        $("#profile_form :input").prop("disabled", true);
      }
    },
    initialSetup() {
      setTimeout(() => {
        document.getElementById("telephone") &&
          Inputmask("099-99999999").mask(document.getElementById("telephone"));
      }, 1000);
    },
    update(e) {
      let form = $(e.target);
      let btn = $("#submit_btn");

      this.has_submit_attempt = true;

      if (!this.is_username_valid()) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        return;
      }

      form.validate({
        ignore: ":hidden",

        rules: {
          email: {
            required: true,
          },
          telephone: {
            required: true,
          },
          phone: {
            required: true,
          },
          com_name_fa: {
            required: true,
          },
          com_name_en: {
            required: true,
          },
          national_legal_code: {
            required: true,
          },
          register_number: {
            required: true,
          },
          register_date: {
            required: true,
          },

          signature_holder_first_name_fa: {
            required: true,
          },
          signature_holder_last_name_fa: {
            required: true,
          },
          signature_holder_father_name_fa: {
            required: true,
          },
          signature_holder_first_name_en: {
            required: true,
          },
          signature_holder_last_name_en: {
            required: true,
          },
          signature_holder_father_name_en: {
            required: true,
          },
          signature_holder_national_code: {
            required: true,
          },
          signature_holder_birth_date: {
            required: true,
          },

          technical_agent_first_name: {
            required: true,
          },
          technical_agent_last_name: {
            required: true,
          },
          technical_agent_phone_number: {
            required: true,
          },
          technical_agent_telephone_number: {
            required: true,
          },
          technical_agent_email: {
            required: true,
          },
          technical_agent_national_code: {
            required: true,
          }
        },
      });

      if (!form.valid()) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        return;
      }

      let params = {
        username: this.user.username,
        email: this.user.email,
        phone: this.user.phone,
        telephone: this.user.telephone,
        com_name_fa: this.user.com_name_fa,
        com_name_en: this.user.com_name_en,
        national_legal_code: this.user.national_legal_code,
        register_number: this.user.register_number,
        register_date: this.user.register_date,

        signature_holder_first_name_fa:
          this.user.signature_holder.first_name_fa,
        signature_holder_last_name_fa: this.user.signature_holder.last_name_fa,
        signature_holder_father_name_fa:
          this.user.signature_holder.father_name_fa,
        signature_holder_first_name_en:
          this.user.signature_holder.first_name_en,
        signature_holder_last_name_en: this.user.signature_holder.last_name_en,
        signature_holder_father_name_en:
          this.user.signature_holder.father_name_en,
        signature_holder_national_code:
          this.user.signature_holder.national_code,
        signature_holder_birth_date: this.user.signature_holder.birth_date,

        technical_agent_first_name: this.user.technical_agent.first_name,
        technical_agent_last_name: this.user.technical_agent.last_name,
        technical_agent_phone_number: this.user.technical_agent.phone_number,
        technical_agent_telephone_number:
          this.user.technical_agent.telephone_number,
        technical_agent_email: this.user.technical_agent.email,
        technical_agent_national_code: this.user.technical_agent.national_code,
      };

      this.form_submit_loading = true;
      userService
        .update_legal_user(params)
        .then((response) => {
          this.$store.commit("user/success", response.data.data);
          this.wizard.current_step = 2;
        })
        .catch(({ response }) => {
          if (response.data) {
            form.validate().showErrors(response.data.data);
          }
          this.showMsg(form, "danger", response.data.message);
          window.scrollTo({top: 0, behavior: 'smooth'});
        })
        .finally(() => {
            this.form_submit_loading = false;
        });
    },
    getYear() {
      return new Date().getFullYear() - 721;
    },
  },
};
</script>
